var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pu_wd_def_min pu_wrapper_main"},[_c('inc_user_head'),_c('inc_user_top'),_c('div',{staticClass:"dev_wrapper_middle pu_wrapper_middle_normal"},[_c('inc_user_banner_top'),_c('inc_user_left'),_c('inc_user_title'),_c('div',{staticClass:"pu_wd_def_max pu_layoutContent"},[_vm._v(" 계정 등록 ")])],1),_c('inc_user_foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }